<template>
    <div class="quantity-container">
        <div class="quantity-wrapper">
            <button :disabled="quantity <= 1" @click.prevent="decrease">−</button>
            <input id="quantity" v-model="quantity" type="text" readonly />
            <button @click.prevent="increase">+</button>
        </div>
    </div>
</template>

<script setup>
import { ref, watch } from 'vue';
import { defineProps, defineEmits } from 'vue';

const props = defineProps({
    modelValue: {
        type: Number,
        required: true
    }
});

const emit = defineEmits(['update:modelValue']);

const quantity = ref(props.modelValue);

const increase = () => {
    quantity.value++;
    emit('update:modelValue', quantity.value);
};

const decrease = () => {
    if (quantity.value > 1) {
        quantity.value--;
        emit('update:modelValue', quantity.value);
    }
};

watch(() => props.modelValue, (newValue) => {
    quantity.value = newValue;
});
</script>

<style scoped>
.quantity-container {
    display: flex;
    flex-direction: column;
    font-family: Arial, sans-serif;
    width: 100%;
}

.quantity-wrapper {
    display: flex;
    align-items: center;
    justify-content: space-between;
    /* Distribuye los elementos horizontalmente */
    border: 1px solid #4a90e2;
    border-radius: 5px;
    width: 100%;
    /* Ocupa el 100% del contenedor */
    height: 42px;
    background-color: white;
    overflow: hidden;
}

button {
    background: none;
    border: none;
    padding: 10px;
    cursor: pointer;
    font-size: 18px;
    color: #4a90e2;
    flex: 1;
    /* Hace que los botones ocupen el mismo espacio */
    text-align: center;
}

button:disabled {
    color: #ccc;
    cursor: not-allowed;
}

input {
    text-align: center;
    border: none;
    flex-grow: 1;
    /* Permite que el input se expanda */
    background-color: #f4f4f4;
    font-size: 18px;
    font-weight: bold;
    width: 20px;
    /* Ancho suficiente para el número */
}
</style>
